module.exports = __webpack_public_path__ + "1b468a9d022b4c4e39daefcb23ea06a5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-firefighter.png
// module id = 2725
// module chunks = 0